module.exports = __webpack_public_path__ + "assets/vendors/bootstrap-glyphicons-halflings-white.png";


//////////////////
// WEBPACK FOOTER
// ./legacy_modules/bootstrap/img/glyphicons-halflings-white.png
// module id = iRYH
// module chunks = 0